<template>
  <div class="text-center">
    <span class="button-3" v-on:click="$emit('paginate', 'prev')">
      Prev
    </span>
    <span class="button-3 mx-2">
      {{ currentPage }}
    </span>
    <span
      class="button-3"
      data-cy="paginate-next-button"
      v-on:click="$emit('paginate', 'next')"
    >
      Next
    </span>
  </div>
</template>
<script>
export default {
  props: ["currentPage"]
};
</script>
<style lang="scss">
.button-3 {
  @apply px-4 py-2 rounded bg-blue-lighter text-white cursor-pointer;
}
</style>
